import { use_effect } from '@/hooks/_base/use_effect';
import { set_interval, set_timeout } from '@/utils/utils_client';
import { useState } from 'react';

interface Props {
  text?: string;
  timeout_ms: number;
  onTimerComplete?: VoidFunction;
}

//be careful with onTimerComplete.
//use_effect doesnt have dependency of this function.
//so use useCallback to cache it or use refs inside onTimerComplete
export function UI_PRIMITIVE__progress_bar({ text = '', timeout_ms, onTimerComplete }: Props) {
  const timeout_seconds = Math.floor(timeout_ms / 1000);

  const [start, set_start] = useState(false);
  const [time_left, set_time_left] = useState(timeout_seconds - 1);

  /*
   * EFFECTS
   */

  use_effect(() => {
    const timeout_id_start = set_timeout(() => set_start(true), 0);
    const interval_id = set_interval(() => set_time_left(s => (s <= 0 ? 0 : s - 1)), 1000);
    const timeout_id_callback = set_timeout(() => onTimerComplete?.(), timeout_ms - 1000);

    return () => {
      clearTimeout(timeout_id_start);
      clearInterval(interval_id);
      clearTimeout(timeout_id_callback);
    };
  });

  /*
   * RENDERS
   */

  function render_entity_type() {
    let out = <></>;

    if (text) {
      out = <div className="text-xs text-bar-foreground mb-2">{text}</div>;
    }

    return out;
  }

  /*
   * HTML
   */

  return (
    <>
      {render_entity_type()}
      <div className="flex gap-1 items-center">
        <div className="relative w-full h-1 bg-component overflow-hidden">
          <div
            className="h-1 bg-bar-foreground origin-left"
            style={{
              transform: start ? 'scaleX(0)' : 'scaleX(1)',
              transition: `transform ${timeout_seconds}s linear`,
            }}
          />
        </div>
        <div className="text-xs text-bar-foreground">{time_left}s</div>
      </div>
    </>
  );
}
